import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { spineLoader } from '@play-co/timestep-spine';
import { downscale } from 'src/conf/scale';
import { HeaderFire } from '../components/HeaderFire';

const folder = 'assets/minigame/rescueLevel/theme-fire';

const assetMap = {
  iconSmall: `${folder}/icon_small.png`,
  iconLarge: `${folder}/icon_large.png`,
  dream: `${folder}/dream.png`,
  header: {
    loadMethod: spineLoader,
    url: `${folder}/animation/house-on-fire`,
  },
};

export const rescueLevelThemeFire = {
  getHeader: (opts: ViewOpts) => new HeaderFire(opts),
  getAssets: () => Object.values(assetMap),
  getDream: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.dream,
      width: downscale(253),
      height: downscale(209),
      offsetX: -downscale(253) / 2,
      offsetY: -downscale(209) / 2 - 15,
      ...opts,
    });
  },
  getIconLarge: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.iconLarge,
      width: downscale(380),
      height: downscale(497),
      centerOnOrigin: true,
      ...opts,
    });
  },
  getIconSmall: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.iconSmall,
      width: downscale(158),
      height: downscale(185),
      centerOnOrigin: true,
      ...opts,
    });
  },
  getHeaderBg: () => assetMap.header.url,
  getHeaderFg: () => assetMap.header.url,
};
